import React, { Component, createRef } from "react";
import { Layout, MTools, Player } from "@/components";
import BetterScroll from "@better-scroll/core";
import PullUp from "@better-scroll/pull-up";
import { RouteComponentProps, withRouter } from "dva/router";
import { getBbsList } from "@/services/api";
import styles from "./index.less";
import classNames from "classnames";
import moment from 'moment';

interface ForumListProps {}
interface ForumListState {
  list: any;
  loading: boolean;
  hasMore: boolean;

  topicId: string | null;
  forumList: any[];
}

type ForumListInfo = ForumListProps & RouteComponentProps;

BetterScroll.use(PullUp);

class ForumList extends Component<ForumListInfo, ForumListState> {
  indexRef: any;
  bs: any;
  el: any;

  constructor(props: ForumListInfo) {
    super(props);
    this.state = {
      list: {},
      loading: false,
      hasMore: true,
      topicId: null,
      forumList: [],
    };
    this.indexRef = createRef();
    this.el = createRef();
  }

  componentDidMount() {
    // 主论坛
    this.getBbsList("1");
    // 子论坛
    this.getBbsList("2");
  }

  getBbsList = async (type: string) => {
    const result = await getBbsList(type);
    if (result.success) {
      if (type == "1") {
        this.setState({
          list: result.data,
        });
      } else {
        this.setState({
          forumList: result.data,
        });
      }
    } else {
      MTools.Tips(
        "error",
        (result && result.message) || "系统异常，请刷新再试"
      );
    }

    this.setState({
      loading: false,
    });
  };

  getEL = (video: any) => {
    this.el.current = video;
  };

  onHref = (id: string) => {
    if(id != ''){
      MTools.Url.gotoUrl(`/app/ForumDetail/${id}`)
    }
  }

  render() {
    const { forumList, list } = this.state;
    const local = window.location.pathname.split("/");
    const Id = local.length ? local[local.length - 1] : null;
    return (
      <div className={styles.index} ref={this.indexRef}>
        <Layout padding={0}>
          <div className={styles.wrap}>
            <div className={styles.wrap_header}>
              {
                  <dl className={styles.main_forum}>
                    <dt>开幕式暨主论坛</dt>
                    <dd onClick={()=>this.onHref(list?.[0]?.id??'')}>
                      <img src="https://s.newscdn.cn/file/2022/09/ff6cf648-99cf-4258-8278-0a22930ec3cc.png" alt="" />
                    </dd>
                  </dl>
              }

              {
                  <dl className={styles.sub_orum}>
                    <dt>分论坛</dt>
                    <dd>
                      {forumList.map((item, i) => {
                        return (
                          <div
                            key={i}
                            className={classNames(styles.card, styles.nomal)}
                            onClick={()=>this.onHref(item.id)}
                          >
                            <div className={styles.card_img}>
                              <img src={item.cover} alt="" />
                            </div>
                            <div className={styles.card_title}>
                              <div className={styles.card_title_text}>
                                <div className={styles.paly_title}>
                                  {item.title}
                                </div>
                              </div>
                              <div className={styles.card_time}>
                                {moment(item.startTime).format('YYYY年M月D日 HH:mm')}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </dd>
                  </dl>
              }
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

export default withRouter(ForumList);
